// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { Language, RoleResource, RoleResourceConstraint } from "../schema";
import { serialize_Language_internal, deserialize_Language_internal } from "./Language";
import { serialize_RoleResource_internal, deserialize_RoleResource_internal } from "./RoleResource";

export function serialize_RoleResourceConstraint_internal(value: RoleResourceConstraint): unknown {
  return ((value: { corporateIds: number[]; customerId: number; languages: Language[]; resource: RoleResource }): unknown => {
    return {
      corporateIds: ((value: number[]): unknown => {
        return value.map((value: number): unknown => {
          return value;
        });
      })(value["corporateIds"]),
      customerId: ((value: number): unknown => {
        return value;
      })(value["customerId"]),
      languages: ((value: Language[]): unknown => {
        return value.map((value: Language): unknown => {
          return serialize_Language_internal(value);
        });
      })(value["languages"]),
      resource: ((value: RoleResource): unknown => {
        return serialize_RoleResource_internal(value);
      })(value["resource"]),
    };
  })(value);
}
export function serialize_RoleResourceConstraint(obj: RoleResourceConstraint): string {
  return renderJsonWithNumbersAsBigint(serialize_RoleResourceConstraint_internal(obj));
}
export function deserialize_RoleResourceConstraint_internal(value: unknown): ParserResult<RoleResourceConstraint> {
  return ((
    value: unknown,
  ): ParserResult<{
    corporateIds: number[];
    customerId: number;
    languages: Language[];
    resource: RoleResource;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/RoleResourceConstraint]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/RoleResourceConstraint]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "corporateIds")) {
      return { success: false, reason: `[#/components/schemas/RoleResourceConstraint/corporateIds]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'corporateIds'.` };
    }
    const parsed_corporateIds = ((): ParserResult<number[]> => {
      return ((value: unknown): ParserResult<number[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/RoleResourceConstraint/corporateIds]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<number> => {
          if (typeof value === "number") {
            return { success: true, value: value };
          }
          return { success: false, reason: `[#/components/schemas/RoleResourceConstraint/corporateIds]: '${value}' expected to be of type number.` };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/RoleResourceConstraint/corporateIds]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["corporateIds"]);
    })();
    if (!parsed_corporateIds.success) {
      return { success: false, reason: parsed_corporateIds.reason };
    }
    if (!hasProp(value, "customerId")) {
      return { success: false, reason: `[#/components/schemas/RoleResourceConstraint/customerId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerId'.` };
    }
    const parsed_customerId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/RoleResourceConstraint/customerId]: '${value}' expected to be of type number.` };
      })(value["customerId"]);
    })();
    if (!parsed_customerId.success) {
      return { success: false, reason: parsed_customerId.reason };
    }
    if (!hasProp(value, "languages")) {
      return { success: false, reason: `[#/components/schemas/RoleResourceConstraint/languages]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'languages'.` };
    }
    const parsed_languages = ((): ParserResult<Language[]> => {
      return ((value: unknown): ParserResult<Language[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/RoleResourceConstraint/languages]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<Language> => {
          return deserialize_Language_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/RoleResourceConstraint/languages]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["languages"]);
    })();
    if (!parsed_languages.success) {
      return { success: false, reason: parsed_languages.reason };
    }
    if (!hasProp(value, "resource")) {
      return { success: false, reason: `[#/components/schemas/RoleResourceConstraint/resource]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'resource'.` };
    }
    const parsed_resource = ((): ParserResult<RoleResource> => {
      return ((value: unknown): ParserResult<RoleResource> => {
        return deserialize_RoleResource_internal(value);
      })(value["resource"]);
    })();
    if (!parsed_resource.success) {
      return { success: false, reason: parsed_resource.reason };
    }
    return { success: true, value: { corporateIds: parsed_corporateIds.value, customerId: parsed_customerId.value, languages: parsed_languages.value, resource: parsed_resource.value } };
  })(value);
}
export function deserialize_RoleResourceConstraint(str: string): ParserResult<RoleResourceConstraint> {
  return deserialize_RoleResourceConstraint_internal(parseJsonWithNumbersAsBigint(str));
}
